import React, { useCallback, useContext } from 'react';
import { styled } from '@linaria/react';
import { HotelCardContext } from 'components/HotelCardContext';
import { useHotelCardActions } from 'hooks/useHotelCardActions';
import { getParametrizedHotelContext, getParametrizedHotelInfoContext } from 'middleware/analytics/selectors';
import { SelectedElement } from 'utils/selectedElement';
import { Box } from '@daedalus/atlas/helpers/Box';
import { cssTheme } from '@daedalus/atlas/themes';
import { getClosestDataIdToEventTarget } from '@daedalus/core/src/_web/utils/browser';
import { AnalyticsContext } from '@daedalus/core/src/analytics/types/Events';
interface Props {
  gallerySlot: React.ReactNode;
  galleryButtonSlot: React.ReactNode;
  propertyDetailsSlot: React.ReactNode;
  offerSlot: React.ReactNode;
}
export const GALLERY_WIDTH = 117;
export const GALLERY_BUTTON_POSITION = cssTheme.layout.spacing.s300;
const _exp = /*#__PURE__*/() => Box;
const Container = /*#__PURE__*/styled(_exp())({
  name: "Container",
  class: "cygecxo",
  propsAsIs: true
});

/**
 * Experiment layout for the hotel card with no offers
 * Added as part of 2a3185b4-mobile-hotel-card-no-offers
 */
export const ExperimentalNoOffersCardLayout = ({
  gallerySlot,
  galleryButtonSlot,
  propertyDetailsSlot,
  offerSlot
}: Props) => {
  const {
    hotelId
  } = useContext(HotelCardContext);
  const {
    onShowHotelDetails,
    trackUserHotelCardClicked
  } = useHotelCardActions();
  const handleHotelCardClick = useCallback((e: React.MouseEvent) => {
    if (!hotelId) return;
    trackUserHotelCardClicked({
      hotelId: hotelId,
      component: 'ExperimentalNoOffersCardLayout',
      selectedElement: getClosestDataIdToEventTarget(e) || SelectedElement.BlankSpace
    });
    const analyticsContext = {
      [AnalyticsContext.HotelContext]: getParametrizedHotelContext(hotelId),
      [AnalyticsContext.HotelInfoContext]: getParametrizedHotelInfoContext(hotelId)
    };
    onShowHotelDetails(hotelId, analyticsContext);
  }, [hotelId, trackUserHotelCardClicked, onShowHotelDetails]);
  return <Container display="flex" flexDirection="row" onClick={handleHotelCardClick}>
      <Box position="relative">
        {gallerySlot}
        <Box position="absolute" top={GALLERY_BUTTON_POSITION} left={GALLERY_BUTTON_POSITION}>
          {galleryButtonSlot}
        </Box>
      </Box>
      <Box flex="1" display="flex" flexDirection="column" justifyContent="space-between" paddingTop="s300" paddingBottom="s400" paddingLeft="s400" gap="s500" overflow="hidden">
        <Box display="flex" alignSelf="flex-start" width="100%">
          {propertyDetailsSlot}
        </Box>
        <Box display="flex" alignSelf="flex-end" paddingRight="s400">
          {offerSlot}
        </Box>
      </Box>
    </Container>;
};

require("./Layout.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Layout.tsx");